var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHome = function SvgHome(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#335E6A",
    d: "M5 15.833h2.5v-5h5v5H15v-7.5l-5-3.75-5 3.75zM3.333 17.5v-10L10 2.5l6.667 5v10h-5.834v-5H9.167v5z"
  })));
};
export { SvgHome as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMjAiIHZpZXdCb3g9IjAgMCAyMCAyMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGcgaWQ9Ikljb24gLyBob21lIj4KPHBhdGggaWQ9IlZlY3RvciIgZD0iTTUuMDAwMDQgMTUuODMzM0g3LjUwMDA0VjEwLjgzMzNIMTIuNVYxNS44MzMzSDE1VjguMzMzMzNMMTAgNC41ODMzM0w1LjAwMDA0IDguMzMzMzNWMTUuODMzM1pNMy4zMzMzNyAxNy41VjcuNUwxMCAyLjVMMTYuNjY2NyA3LjVWMTcuNUgxMC44MzM0VjEyLjVIOS4xNjY3MVYxNy41SDMuMzMzMzdaIiBmaWxsPSIjMzM1RTZBIi8+CjwvZz4KPC9zdmc+Cg==";